import React, { useState, useEffect } from 'react';
import './dashboard.css'; 
import { useAuth } from '../AuthContext';

const Dashboard = () => {
    
    const { loggedIn, userID, userName } = useAuth();
    
    //User info
    const [joinedDate, setJoinedDate] = useState(null);
    const [relationshipLevel, setRelationshipLevel] = useState(null);
    const [membershipLevel, setMembershipLevel] = useState(null);

    //Stored Stripe Info
    const [stripeCustomerID, setStripeCustomerID] = useState(null);
    const [stripeSubscriptionID, setStripeSubscriptionID] = useState(null);
    
    //Info from stripe
    const [stripeStartDate, setStripeStartDate] = useState(null)
    const [stripeLastBilled, setStripeLastBilled] = useState(null);
    const [stripeNextBill, setStripeNextBill] = useState(null);

    const [isCanceled, setIsCanceled] = useState(false);

    
    //back home if not logged in
    useEffect(() => {
        if (!loggedIn) {
            window.location.href = '/';
        }
    }, [loggedIn]);

    //fetch non stripe related info from database
    useEffect(() => {
        if (!userID) return;
        fetch('/api/get_user_information', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId: userID }),
        })
        .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data && data.length > 0) {
                    const userData = data[0];
                    const formattedDate = new Date(userData.date_joined).toLocaleDateString('en-US');
                    setJoinedDate(formattedDate);
                    setRelationshipLevel(userData.relationship_level);
                    setMembershipLevel(userData.membership_level);
                } else {
                    console.error("No user data found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching user data:", error);
            });
    },[userID]);
    
    //Fetch Stripe related info from database
    useEffect(() => {
        if (!userID) return; 
        fetch('/api/get_user_membership_info', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId: userID }),
        })   
        .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            }
        )
        .then(data => {
            if(data && data.length){
                const storedUserMembershipInfo = data[0];
                setStripeCustomerID(storedUserMembershipInfo.stripe_customer_id);
                setStripeSubscriptionID(storedUserMembershipInfo.sub_id);

            }else{
                console.error("No user data found in response");
            }
        }
        )
        
    }, [userID]);

    //fetch sub info from stripe
    useEffect(() => {
        if(stripeSubscriptionID){
            fetch('/api/get_sub_info',  {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({subID:stripeSubscriptionID}),
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data =>{
               if(data){

                    setStripeStartDate(data.data.startDate);
                    setStripeLastBilled(data.data.lastBill);
                    setStripeNextBill(data.data.nextBill);
                    
                    if(data.data.canceled && !isCanceled){
                        setIsCanceled(true);
                    }

                    
                }else{
                    console.log("No subscription data found ")
                }
            })
    }
    }, [stripeSubscriptionID, isCanceled]);
    
    //Function to determine if the user has an active subscription
    function activeSub(tier){
        if(tier !== 'base'){
            if(isCanceled){
                return 'Canceled'
            }else{
                return 'Active'
            }        
        }else{
            return 'No subscription'
        }
    }

    //Function to cancel subscription
    const cancelSubscription = async () => {
        if (!window.confirm('Are you sure you wish to cancel your subscription? This cannot be undone.')){
            return
        }

        //extra gatef
        if(!userID || !stripeSubscriptionID){
            alert('Cannot cancel subscription. Either you are not logged in or you do not have a subscription')
            return
        }
        
        try{
            const response = await fetch('/api/cancel_sub',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    subID: stripeSubscriptionID
                }),
            });
            
            if(response.ok){
                const result = await response.json();
                setIsCanceled(true)
                console.log('Subscription cancelation successfully');
                

            }else{
                const errorData = await response.json();
                console.error('Error during subscription cancelation', errorData);
                alert(`Failed to cancel subscription: ${errorData.message || 'Please try again'}`);    
            }


        }catch(error){
            console.error('Error during subscription cancelation', error);
            alert('An unexpected error occurred. Please try again later');
        }

    }

    return (
        <div className="dashboard-container">
            
            <div className="header-container">
                <h1 id="main-header">Welcome to your dashboard {userName}!</h1>
            </div>

            <div className="dashboard-info-container">
                
                <div className="info-row-container">

                    <div className='info-card' id='my-info'>
                        <h3 className='info-header'>{userName} stats</h3>
                        <table className="stat-table">
                            <tbody>
                                <tr>
                                    <td><strong>Relationship Level:</strong></td>
                                    <td>{relationshipLevel}</td>
                                </tr>
                                <tr>
                                    <td><strong>Membership Level:</strong></td>
                                    <td>{membershipLevel}</td>
                                </tr>
                                <tr>
                                    <td><strong>Joined Date:</strong></td>
                                    <td>{joinedDate}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='info-card' id='membebrship-info'>
                        <h3 className='info-header'>{userName} membership info</h3>
                        <table className='membership-table'>
                            <tbody>
                                <tr>
                                    <td><strong>Subscription status:</strong></td>
                                    <td>{activeSub(membershipLevel)}</td>
                                </tr>   

                                <tr>
                                    <td><strong>Last Billing Date:</strong>s</td>
                                    <td>{stripeLastBilled}</td>
                                </tr>

                                <tr>
                                    <td><strong>{isCanceled ? 'Canceling on:' : 'Next Billing Date'}</strong></td>
                                    <td>{stripeNextBill}</td>
                                </tr>

                                <tr>
                                    <td>Canceel Subscription</td>
                                    <td><button onClick={cancelSubscription} className='cancel_button' disabled={isCanceled}>Cancel</button></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                </div>


            </div>  
        </div>
    );
};

export default Dashboard;
